import React from 'react';
import { View } from 'react-native';

import { IStaticPage } from 'remote/queries/static-page';
import { AnchorContextProvider } from 'utils/static-page/hooks/useAnchorContext';

import theme from '../theme';

import { StaticPageContainer } from './static-page-container';
import { WidgetType } from './widgetEnums';

export const RenderCurrentStaticPage = ({
  currentPage,
  currentPageOverrideCss = '',
  hideFooter = false,
}: {
  currentPage: IStaticPage;
  currentPageOverrideCss?: string;
  hideFooter?: boolean;
}) => {
  const redirectHtml = currentPage.redirectUrl?.en
    ? `<meta http-equiv="refresh" content="0; url=${currentPage.redirectUrl?.en}">`
    : null;
  const html =
    redirectHtml ||
    `
  <style type="text/css">
    html, body {
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      margin: 0;
    }

    .static-page {
      color: ${Styles.color.black};
      background-color: ${theme.backgroundColor};
    }

    ${currentPage && currentPage.pageCSS && currentPage.pageCSS.code}
    ${currentPageOverrideCss}
  </style>

  <div class="static-page">
    ${currentPage.pageHtml?.code}
  </div>
  `;

  const hasWidgets = !!currentPage.widgets;
  const hasHtml = !!currentPage.pageHtml?.code || !!redirectHtml;

  const webView = hasHtml
    ? {
        _type: WidgetType.WEB_VIEW,
        renderWebView: () => (
          <View
            // Web: article landmark so policy/terms HTML is a named region distinct from <main>
            style={{ flex: 1, alignSelf: 'stretch', width: '100%' }}
            role="article"
            accessibilityLabel={currentPage.title ?? 'Policy document'}
            nativeID="static-page-body-article"
          >
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </View>
        ),
      }
    : undefined;

  const fixedHeightContent = !hasWidgets && !!webView && webView.renderWebView();
  const currentWidgets = currentPage?.widgets ? [...currentPage.widgets] : [];

  const listData = hasHtml ? [webView, ...currentWidgets] : [...currentWidgets];

  return (
    <AnchorContextProvider>
      <StaticPageContainer
        currentPage={currentPage}
        isScroll={hasWidgets}
        fixedHeightContent={fixedHeightContent || undefined}
        data={listData}
        webViewLoading={hasHtml}
        hideFooter={hideFooter}
      />
    </AnchorContextProvider>
  );
};
